import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { WelcomeModal } from '@ibk/shared-ui';
import blackCards from './assets/migration-welcome-black-cards.png';
import styles from './MigrationWelcomeModal.module.css';
export function MigrationWelcomeModal(props) {
    return (_jsx("div", { className: styles.presentation, "data-testid": 'migration-welcome-presentation', children: _jsx(WelcomeModal, { ...props, headerImageSrc: blackCards, actionsButtonSize: 'medium', onboardingWelcomeActions: true, primaryActionLeftIcon: 'none', primaryActionRightIcon: 'none' }) }));
}
